import {
  observable,
  autorun,
  action,
  computed,
  toJS,
  extendObservable,
} from 'mobx'
import { persist } from 'mobx-persist'
class NotificationStore {
  @observable
  item = {} // รายการที่ดูปัจจจุบัน

  @observable
  items = []

  @observable
  itemReadData = null // รายการที่กดรับทราบ

  constructor() {
    autorun(() => {})
  }

  @computed get itemRead() {
    return toJS(this.itemReadData)
  }
  @computed get count() {
    const items = toJS(this.itemReadData)
    return items.length
  }

  @action
  setItem = (data) => {
    this.item = data
  }

  @action
  setItems = (data) => {
    this.items = data
  }

  @action
  setItemRead = (data) => {
    this.itemReadData = data
  }
}

export default new NotificationStore()
